// hooks/useFetchMedia.js
import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useDebouncedKeyword from '../../../hooks/useDebouncedKeyword';
import getWorkRecords from '../../../actions/api/record/getWorkRecords';
import { isGuest } from '../../../lib/tools';

/**
 * 写真選択ダイアログでの写真取得処理を行うカスタムフック
 * TODO: テストを書く
 * @param {number} delay - デバウンスする時間
 * @param {string} successActionType - 写真一覧取得API成功時のアクションタイプ
 * @returns
 */
const useFetchMedia = ({ delay = 500, successActionType }) => {
  const dispatch = useDispatch();
  const apiToken = useSelector(state => state.main.apiToken);
  const { timelines, totalNumber, totalPages } = useSelector(
    state => state.report.selectableReportMedia || {},
  );
  const operatorId = useSelector(state => state.main.userInfo?.operatorId);
  const innerRole = useSelector(state => state.main.innerRole);
  const targetGroupId = useSelector(state => state.main.targetGroupId);

  const [keyword, setKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [isOnlyMyMediaChecked, setIsOnlyMyMediaChecked] = useState(false);

  const debouncedKeyword = useDebouncedKeyword({ value: keyword, delay });

  useEffect(() => {
    const requestParams = {
      numberPerPage: 100,
      page: currentPage,
      keyword: debouncedKeyword,
      sortColumns: [{ column: 'recordedDate', order: 'D' }],
      isDeleted: false,
      mediaTypes: ['1'],
    };
    if (targetGroupId) {
      requestParams.groupIds = [targetGroupId];
    }
    if (isOnlyMyMediaChecked || isGuest(innerRole)) {
      requestParams.operatorId = operatorId;
    }

    dispatch(getWorkRecords(apiToken, requestParams, successActionType));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, debouncedKeyword, isOnlyMyMediaChecked]);

  // 検索条件が変更されたらページを1ページ目に戻す
  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedKeyword, isOnlyMyMediaChecked]);

  const handleSearchChange = useCallback(e => {
    setKeyword(e.target.value);
  }, []);

  const handleCheckboxChange = useCallback(() => {
    setIsOnlyMyMediaChecked(prev => !prev);
  }, []);

  return {
    timelines,
    totalNumber,
    totalPages,
    currentPage,
    setCurrentPage,
    keyword,
    setKeyword,
    isOnlyMyMediaChecked,
    setIsOnlyMyMediaChecked,
    handleSearchChange,
    handleCheckboxChange,
  };
};

export default useFetchMedia;
